import $ from 'jquery';
import { PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import { formatPrice } from '@oem-theme/utilities.js';

const $site = $('.site');
const FREQUENCY = $site.data('frequency')

const formatSrpPrice = formatPrice.custom(['srp', 'nasapi']);

const dsp = (global.dsp = global.dsp || {});
const apiCalls = new Map();

function getIncentives(itemId) {
  if (!apiCalls.has(itemId)) {
    apiCalls.set(itemId, dsp.incentives.fetch(itemId));
  }

  return apiCalls.get(itemId);
}

function showPrices($card, source = 'dsp', paymentType = null) {
  const types = paymentType ? [paymentType] : ['finance', 'lease'];

  for (const type of types) {
    const $display = $card.find(`.${source}-${type}`);
    const $loader = $display.siblings('.payment-loader');
    $display.removeClass('hidden');
    $loader.remove();
  }
}

// Fill a card's "84 mo · 6.99%" line from the term and rate handleFinance / handleLease used.
function showTerms($widget) {
  const $terms = $widget.closest('.nasapiPayment').find('.payment-terms');
  const term = $widget.data('term');
  const rate = $widget.data('rate');

  if (!$terms.length || term === undefined || rate === undefined) {
    return;
  }

  $terms.text(
    String($terms.data('template')).replace('%1$s', term).replace('%2$s', rate).replace('%%', '%'),
  );
}

export function runNasapi() {
  if (dsp.incentives) {
    $('.nasapi-vehicle-card').each(async function () {
      const $card = $(this);
      const itemID = $card.data('item-id');
      const $financeWidget = $card.find('.nasapi-finance .js-payment');
      const $leaseWidget = $card.find('.nasapi-lease .js-payment');
      let incentives = {};

      // Skip cards with no NASAPI prices.
      if (!$financeWidget.length && !$leaseWidget.length) {
        showPrices($card, 'dsp');
        return;
      }

      // Try and load incentives from NASAPI.
      try {
        incentives = await getIncentives(itemID);
      } catch (err) {
        console.log(`Error loading incentives for ${itemID}:`, err.message ?? err);
        showPrices($card, 'dsp');
        return;
      }

      // Update Finance display.
      const financeValue = handleFinance(incentives.finance ?? {}, $financeWidget, itemID);
      $financeWidget.text(formatSrpPrice(financeValue));
      showTerms($financeWidget);
      showPrices($card, financeValue ? 'nasapi' : 'dsp', 'finance');

      // Update Lease display.
      const leaseValue = handleLease(incentives.lease ?? {}, $leaseWidget, itemID);
      $leaseWidget.text(formatSrpPrice(leaseValue));
      showTerms($leaseWidget);
      showPrices($card, leaseValue ? 'nasapi' : 'dsp', 'lease');
    });
  }
}

export function handleFinance(finance, $payment, item, disclaimer = null) {
  const terms = [];
  let totalFinanceIncentives = 0;

  if ($payment.length === 0 || !finance.value) {
    return false;
  }

  let price = $payment.data('price') ?? item.lowest_price;
  let disclaimerDetails = disclaimer ?? $payment.data('disclaimer-details') ?? '';

  const values = finance.value;
  for (let key in values) {
    terms.push(values[key]);
  }

  terms.sort((a, b) => (a.value < b.value ? 1 : -1));
  terms.sort((a, b) => (a.from < b.from ? 1 : -1));
  const setTerms = terms[0];

  if (finance.cash) {
    const financeIncentives = finance.cash;
    for (let key in financeIncentives) {
      totalFinanceIncentives += financeIncentives[key].value;
    }
  }

  price = price - totalFinanceIncentives;

  let calcInputs = {
    price: price,
    down: 0,
    term: setTerms.from,
    rate: setTerms.value,
    tradein: 0,
    frequency: FREQUENCY,
    tax: 0,
    frequency: FREQUENCY,
  };

  if (disclaimerDetails.adjustPayments) {
    calcInputs.tax = parseInt(disclaimerDetails.tax);
  }

  $payment.data({ term: calcInputs.term, rate: calcInputs.rate });

  const newCalc = PaymentCalculatorFactory.createCalculator('finance', calcInputs);
  newCalc.calculate();
  const finalPayment = newCalc.payments;
  return finalPayment;
}

export function handleLease(lease, $payment, item, disclaimer = null) {
  const terms = [];
  const values = lease.value;

  if ($payment.length === 0 || !lease.value) {
    return false;
  }

  let price = $payment.data('price') ?? item.lowest_price;
  let residualPrice = $payment.data('residual-price') ?? item.price;
  let disclaimerDetails = disclaimer ?? $payment.data('disclaimer-details') ?? '';

  for (let key in values) {
    terms.push(values[key]);
  }

  terms.sort((a, b) => (a.value < b.value ? 1 : -1));
  terms.sort((a, b) => (a.from < b.from ? 1 : -1));
  const setTerms = terms[0];

  const residualAmount = residualPrice * (setTerms.residual_value / 100);

  if (!residualAmount) {
    return false;
  }

  let totalLeaseIncentives = 0;
  if (lease.cash) {
    const leaseIncentives = lease.cash;
    for (let key in leaseIncentives) {
      const incentive = leaseIncentives[key];
      if (incentive.terms) {
        incentive.terms.forEach(function (leaseTerm) {
            if (leaseTerm.term == setTerms.from) {
              totalLeaseIncentives += leaseTerm.amount;
          }
        });
      } else {
        totalLeaseIncentives += incentive.value ?? 0;
      }
    }
  }

  let calcInputs = {
    price: price - totalLeaseIncentives,
    down: 0,
    term: setTerms.from,
    rate: setTerms.value,
    tradein: 0,
    tax: 0,
    residual: residualAmount,
    frequency: FREQUENCY,
  };

  if (disclaimerDetails.adjustPayments) {
    calcInputs.tax = parseInt(disclaimerDetails.tax);
  }

  $payment.data({ term: calcInputs.term, rate: calcInputs.rate });

  const newCalc = PaymentCalculatorFactory.createCalculator('lease', calcInputs);
  newCalc.calculate();
  const finalPayment = newCalc.payments;

  return finalPayment;
}

document.addEventListener('DOMContentLoaded', runNasapi);
